import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CheckinPassengerAdditionResultEffect } from './checkin-passenger-addition-result.effect';
import { checkinPassengerAdditionResultReducer } from './checkin-passenger-addition-result.reducer';
import {
  CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME,
  CheckinPassengerAdditionResultState,
} from './checkin-passenger-addition-result.state';

/** Token of the CheckinPassengerAdditionResult reducer */
export const CHECKIN_PASSENGER_ADDITION_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<CheckinPassengerAdditionResultState, Action>
>('Feature CheckinPassengerAdditionResult Reducer');

/** Provide default reducer for CheckinPassengerAdditionResult store */
export function getDefaultCheckinPassengerAdditionResultReducer() {
  return checkinPassengerAdditionResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(
      CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME,
      CHECKIN_PASSENGER_ADDITION_RESULT_REDUCER_TOKEN
    ),
    EffectsModule.forFeature([CheckinPassengerAdditionResultEffect]),
  ],
  providers: [
    {
      provide: CHECKIN_PASSENGER_ADDITION_RESULT_REDUCER_TOKEN,
      useFactory: getDefaultCheckinPassengerAdditionResultReducer,
    },
  ],
})
export class CheckinPassengerAdditionResultStoreModule {
  public static forRoot<T extends CheckinPassengerAdditionResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinPassengerAdditionResultStoreModule> {
    return {
      ngModule: CheckinPassengerAdditionResultStoreModule,
      providers: [{ provide: CHECKIN_PASSENGER_ADDITION_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
